import { getWaitingTime } from "utils/dateUtils";
import moment from "moment";
import { getTimeBetweenInSec } from "utils/dateUtils";

export const getWaitingTimeBeforeSampling = (folder) => {
	if (folder.prescriptions && folder.prescriptions.length === 1) {
		let tubes = folder.prescriptions[0].tubes;
		//S'il reste des tubes à prélever
		if (tubes && tubes.filter((t) => t.sampling_time).length > 0 && tubes.filter((t) => !t.sampling_time).length > 0) {
			let firstSampling = tubes
				.filter((t) => t.sampling_time)
				.sort((a, b) => new Date(a.sampling_time) - new Date(b.sampling_time))
				.map((t) => t.sampling_time)[0];
			let nextTimer = tubes
				.filter((t) => !t.sampling_time && t.properties.timer > 0)
				.sort((t) => t.properties.timer)
				.map((t) => t.properties.timer)[0];
			var result = getWaitingTime(moment().toDate(), moment(firstSampling).add(nextTimer, "m").toDate());
			if (result === "" || result === "maintenant") return " "; // en attente
			return result;
		}
	}
	return "";
};

export const getTimeBeforeResult = (folder) => {
	if (
		folder &&
		folder.prescriptions &&
		folder.prescriptions.length > 0 &&
		folder.prescriptions.some((p) => p.tubes && p.tubes.some((t) => t.properties.timer_before_result > 0))
	) {
		const fastResultTube = folder.prescriptions
			.find((p) => p.tubes.some((t) => t.properties.timer_before_result > 0))
			.tubes.find((t) => t.properties.timer_before_result > 0);
		return fastResultTube.sampling_time
			? getTimeBetweenInSec(moment(fastResultTube.sampling_time).add(fastResultTube.properties.timer_before_result, "m"))
			: 0;
	}
	return 0;
};

export const getTimeBeforeSamplingAnalysis = (folder) => {
	if (folder && folder.prescriptions && folder.prescriptions.length > 0) {
		const analysesWithTimeBeforeSampling = folder.prescriptions.flatMap((p) =>
			p.analyses.filter((a) => a.properties?.waiting_time_before_sampling > 0)
		);
		let maxWaitingTime = 0;
		if (analysesWithTimeBeforeSampling && analysesWithTimeBeforeSampling.length > 0) {
			maxWaitingTime = Math.max(...analysesWithTimeBeforeSampling.map((a) => a.properties?.waiting_time_before_sampling));
		}
		return getTimeBetweenInSec(moment(folder.created_at).add(maxWaitingTime, "m"));
	}
	return 0;
};

export const getTimeBeforeNextTube = (folder) => {
	let timeBeforeSampling = 0;
	if (folder && folder.prescriptions && folder.prescriptions.length > 0 && folder.prescriptions.some((p) => p.tubes.some((t) => t.sampling_time))) {
		const nextTubeToSample = folder.prescriptions.flatMap((p) => p.tubes.filter((t) => !t.sampling_time && t.properties.timer > 0));
		const first_sampling = folder.prescriptions.flatMap((p) => p.tubes.filter((t) => t.sampling_time))[0];
		if (nextTubeToSample && nextTubeToSample.length > 0) {
			timeBeforeSampling = getTimeBetweenInSec(moment(first_sampling.sampling_time).add(nextTubeToSample[0].properties.timer, "m"));
		}
	}
	return timeBeforeSampling;
};
